var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupSideMenuSharing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3327 7.33333C10.3327 6.04467 9.28802 5 7.99935 5C6.71068 5 5.66602 6.04467 5.66602 7.33333C5.66602 8.622 6.71068 9.66667 7.99935 9.66667C9.28802 9.66667 10.3327 8.622 10.3327 7.33333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3213 7.5666C10.536 7.63167 10.7637 7.66667 10.9995 7.66667C12.2882 7.66667 13.3329 6.622 13.3329 5.33333C13.3329 4.04467 12.2882 3 10.9995 3C9.7896 3 8.79473 3.92093 8.67773 5.10009",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32115 5.10009C7.20415 3.92093 6.2093 3 4.99935 3C3.71068 3 2.66602 4.04467 2.66602 5.33333C2.66602 6.622 3.71068 7.66667 4.99935 7.66667C5.23522 7.66667 5.46292 7.63167 5.67753 7.5666",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 10.9993C14.6667 9.15842 13.0251 7.66602 11 7.66602",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 12.9993C11.6673 11.1584 10.0257 9.66602 8.00065 9.66602C5.9756 9.66602 4.33398 11.1584 4.33398 12.9993",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00065 7.66602C2.9756 7.66602 1.33398 9.15842 1.33398 10.9993",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupSideMenuSharing);
export default __webpack_public_path__ + "static/media/group_side_menu_sharing.2023ee410e85dee1cf41e58285ca735c.svg";
export { ForwardRef as ReactComponent };